import { useState } from 'react';
import { prepareExportToExcelPayload } from '@/finsight/application/TopCompanies/helpers';
import CompanyRepository from '@/finsight/infrastructure/repository/CompanyRepository';
import { useDIContext } from '@/Framework/DI/DIContext';
import { AlertManager } from '@dealroadshow/uikit/core/components/Alert';
import { getErrorMessage } from '@/Framework/Message/Mapper/getMessage';
import downloadFile from '@/Framework/api/downloadFile';
import Container from '@/Framework/DI/Container';

export default function useExportButtonWithSpinner(serverShowExport) {
  const { container }: { container: Container } = useDIContext();
  const [isExportAvailable, setIsExportAvailable] = useState<boolean>(serverShowExport);
  const [isExportFetching, setIsExportFetching] = useState(false);

  const downloadExcelFile = async (params): Promise<void> => {
    const payload = prepareExportToExcelPayload(params);
    setIsExportFetching(true);
    try {
      const companyRepository = container.get(CompanyRepository);
      const exportUrl = await companyRepository.getExcelExportUrl(payload);
      downloadFile(exportUrl);
    } catch (e) {
      AlertManager.error(getErrorMessage(e));
    } finally {
      setIsExportFetching(false);
    }
  };

  return {
    isExportFetching,
    isExportAvailable,
    downloadExcelFile,
    setIsExportAvailable,
  };
}
